module.exports = __webpack_public_path__ + "exo-latin-100italic.5d74bcc0fa9041da27ab.eot";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-100italic.eot
// module id = ../../../../typeface-exo/files/exo-latin-100italic.eot
// module chunks = styles